import Recorder from 'vue-audio-recorder/src/lib/recorder'
import {convertTimeMMSS} from 'vue-audio-recorder/src/lib/utils'

export default {
  name: "RecorderMixin",
  data() {
    return {
      recorder: this._initRecorder(),
    }
  },
  computed: {
    isRecording() {
      return this.recorder.isRecording
    },
    recordedTime() {
      if (this.time && this.recorder.duration >= this.time * 60) {
        this.stopRecorder()
      }
      return convertTimeMMSS(this.recorder.duration)
    }
  },
  methods: {
    _initRecorder() {
      return new Recorder({
        beforeRecording: () => console.log('before record'),
        afterRecording: () => console.log('after record'),
        pauseRecording: () => console.log('pause record'),
        micFailed: () => console.log('mic failed')
      })
    },
    toggleRecord() {
      if (this.recorder.isRecording) {
        this.stopRecorder()
      } else {
        this.recorder.start()
      }
    },
    stopRecorder() {
      this.recorder.stop()
      const record = this.recorder.records[this.recorder.records.length - 1]
      this.audio = {
        record: record
      }
    }
  },
  beforeDestroy() {
    if (this.recorder.isRecording) this.stopRecorder()
  }
}
